import { loadingAsyncState, HttpResult, AsyncState, unloadedAsyncState } from 'widgets-for-react'
import { FormState, FormData, FieldData, DependencyData } from './types'
import * as Immutable from 'immutable'
import * as i18next from 'i18next'
import { Answer, Field } from '../../models.gen'

export const postSubmissionMonitorCampaign = (form_id: string, form_state: FormState): AsyncState<'ok'> => {
  const data_to_send =
    form_state.form_data.kind == 'loaded' && form_state.form_data.value.steps.length > 0
      ? form_state.form_data.value.steps[0].fields
      : []

  return loadingAsyncState<'ok'>(async () => {
    const recaptchaToken = form_state.recaptcha_token

    const headers = new Headers()
    headers.append('content-type', 'application/json')
    headers.append('X-XSRF-TOKEN', (document.getElementsByName('__RequestVerificationToken')[0] as any).value)

    const fetch_res = await fetch(`/api/v1/campaignmonitor/subscribe/${form_id}`, {
      method: 'put',
      body: JSON.stringify({
        Fields: data_to_send.map((f) => {
          let value = f.user_input
          if (f.Kind == 'CheckboxMultiSelect') {
            value = value.replace(/\]\[/g, '&#&')
            value = value.replace(/\"/g, '')
          }
          return {
            Key: f.title,
            Value: value
          }
        }),
        RecaptchaToken: recaptchaToken
      }),
      credentials: 'include',
      headers: headers
    })

    const result = await fetch_res.text()

    if (result != '') {
      console.error('Campaign monitor error: ', result)
      return { kind: 'result', status: 200, value: 'ok' }
    }

    if (!fetch_res.ok) return { kind: 'failed', status: 400 }
    const res: HttpResult<'ok'> = { kind: 'result', status: 200, value: 'ok' }
    return res
  })
}
export const getFormStateMonitorCampaign = (form_id: string) => getFormStateMonitorCampaignAUX(form_id)([], '')

const getFormStateMonitorCampaignAUX = (form_id: string) => (_: string[], __: string): FormState => {
  const res: FormState = {
    alternative_submit_api: postSubmissionMonitorCampaign,
    alternative_get_api: getFormStateMonitorCampaignAUX(form_id),
    form_started: false,
    recaptcha_token: undefined,
    form_submission_logic: unloadedAsyncState(),
    dependencies_state: Immutable.Map(),
    context: {
      external_options: Immutable.Map<string, string[]>()
    },
    form_data: loadingAsyncState(async () => {
      const fetch_res = await fetch(`/api/v1/campaignmonitor/lists/${form_id}`, {
        method: 'get',
        credentials: 'include',
        headers: { 'content-type': 'application/json' }
      })
      if (!fetch_res.ok) return { kind: 'failed', status: 400 }

      let res0 = undefined

      try {
        res0 = await fetch_res.json()
      } catch {
        res0 = await fetch_res.text()
        if (res0 != '' && typeof res0 == 'string') {
          console.error('Campaign monitor error: ', res0)
          return { kind: 'result', status: 200, value: undefined }
        }
        //otherwise we let it fail and catch the error
      }

      //for now we support only text input. all the other elements are filtered.
      const fields: FieldData[] = res0.map((e, index) => {
        let field: FieldData = {
          Kind: 'Text',
          title: e.FieldName,
          Id: index,
          maybe_answers: [],
          CreatedDate: undefined,
          itemOrderNumber: index,
          user_input: undefined,
          optionalDefaultValue: e.Key || ''
        } as FieldData
        if (e.DataType == 'MultiSelectOne' || e.DataType == 'MultiSelectMany') {
          field = {
            ...field,
            Kind: e.DataType == 'MultiSelectOne' ? 'Dropdown' : 'CheckboxMultiSelect',
            maybe_answers: e.FieldOptions.map((e, index1) => {
              return {
                Id: +`${index}${index1}`,
                CreatedDate: undefined,
                isDefaultSelected: false,
                value: e
              } as Answer
            })
          } as FieldData
        }

        return field
      })

      const dependencies: DependencyData[] = [
        {
          dependency: {
            Id: 1,
            Kind: 'Filled',
            title: 'Field not filled',
            CreatedDate: undefined,
            hideIfViolated: false
          },
          is_met: false,
          dependent_fields: fields.map((f) => ({ FieldId: f.Id }))
        },
        {
          dependency: {
            Id: 2,
            Kind: 'IsEmail',
            title: 'Email not valid',
            CreatedDate: undefined,
            hideIfViolated: false
          },
          is_met: false,
          dependent_fields: fields.filter((f) => f.title.toLowerCase() == 'email').map((f) => ({ FieldId: f.Id }))
        }
      ]

      const data: FormData = {
        steps: [
          {
            step: { Id: 1, orderNumber: 1, title: form_id, CreatedDate: undefined },
            dependencies,
            fields
          }
        ],
        form: {
          title: 'Newsletter',
          Id: form_id as any,
          description: '',
          CreatedDate: undefined,
          remote_submission_link: '',
          store_submissions_locally: false,
          store_submissions_remote: false
        },
        thank_you: {
          Id: 1,
          content: i18next.t('Newsletter:ThankYouText'),
          CreatedDate: undefined
        }
      }

      const res: HttpResult<FormData> = { kind: 'result', status: 200, value: data }
      return res
    })
  }
  return res as any
}

export const postFormSubmissionState = (form_id: number, form_state: FormState): AsyncState<string> => {
  if (form_state.form_data.kind != 'loaded') return unloadedAsyncState()
  //if(!form_state.form_data.value.form.store_submissions_locally) return unloadedAsyncState()
  const recaptchaToken = form_state.recaptcha_token

  const steps = form_state.form_data.value.steps
  let userEmail = ''
  let ConfirmationEmail = 'true'
  const storeLocal = form_state.form_data.value.form.store_submissions_locally
  let files: Immutable.List<File> = Immutable.List<File>()
  form_state.form_data.value.steps.forEach((s) =>
    s.fields.forEach((f) => {
      if (f.Kind == 'UserEmail') userEmail = f.user_input
      if (
        f.Kind == 'Checkbox' &&
        (f.title.toUpperCase().indexOf('CONF') > -1 || f.title.toUpperCase().indexOf('BEVESTIGING') > -1) &&
        f.title.toUpperCase().indexOf('MAIL') > -1
      )
        ConfirmationEmail = f.user_input
      if (f.Kind == 'Attachement' && f.file != undefined) files = files.push(f.file)
    })
  )
  const raw_content = JSON.stringify(
    steps.map((s) => ({
      fields: s.fields
        .filter((x) => x.Kind != 'ReadonlyText')
        .map((x) =>
          x.Kind == 'Attachement' && x.file
            ? { ...x, user_input: x.file.name }
            : x.Kind == 'Checkbox'
            ? x.user_input == 'true'
              ? { ...x, user_input: i18next.t('form:form_checked') }
              : { ...x, user_input: i18next.t('form:form_not_checked') }
            : x
        )
    }))
  )
  const content = {
    RawContent: raw_content,
    UserEmail: userEmail,
    ConfirmationEmail: ConfirmationEmail,
    Context: form_state.custom_context,
    RecaptchaToken: recaptchaToken

  }

  const formData = new FormData()
  formData.append('content', JSON.stringify(content))
  steps.forEach((x) =>
    x.fields.forEach((y) => y.Kind == 'Attachement' && y.file && formData.append(y.file.name, y.file))
  )

  return loadingAsyncState(async () => {
    const headers = new Headers()
    headers.append('X-XSRF-TOKEN', (document.getElementsByName('__RequestVerificationToken')[0] as any).value)
    
    const fetch_res = await fetch(`/api/v1/CustomFormLogic/SubmitFormData/${form_id}`, {
      method: 'put',
      body: formData,
      credentials: 'include',
      headers: headers
    })

    const json = await fetch_res.json()
    if (files.count() > 0 && storeLocal) {
      await upload_files(json.id, json.upload_hash, files.toArray())
    }
    if (!fetch_res.ok) return { kind: 'failed', status: 400 }
    const res: HttpResult<string> = { kind: 'result', status: 200, value: 'ok' }
    return res
  })
}

export const getFormState = (events: string[], form_title: string): FormState => {
  const res: FormState = {
    form_submission_logic: unloadedAsyncState(),
    form_started: false,
    recaptcha_token: undefined,
    dependencies_state: Immutable.Map(),
    context: {
      external_options: Immutable.Map<string, string[]>().set('locationArray', events)
    },
    form_data: loadingAsyncState(async () => {
      const fetch_res = await fetch(`/api/v1/CustomFormLogic/GetFormData/${form_title}`, {
        method: 'get',
        credentials: 'include',
        headers: { 'content-type': 'application/json' }
      })
      if (!fetch_res.ok) return { kind: 'failed', status: 400 }
      const data = await fetch_res.json()
      data.steps = data.steps.map((step) => ({
        ...step,
        fields: step.fields.map((f) => {
          const field: Field = f.field
          field.Kind = f.field_kind
          const maybe_answers = f.maybe_answers
          let result: any = null
          if (field.Kind == 'SimpleDate') {
            result = { ...field, user_input: '', maybe_answers }
          } else if (field.Kind == 'CheckboxMultiSelect') {
            const user_input = maybe_answers.map((a): string => {
              if (a.isDefaultSelected) {
                return '[' + a.value + ']'
              }
              return ''
            })
            if (user_input.length == 0) {
              result = { ...field, user_input: '', maybe_answers }
            } else {
              result = { ...field, user_input: user_input.reduce((a, b) => a + b), maybe_answers }
            }
          } else {
            result = {
              ...field,
              user_input: field.optionalDefaultValue ? field.optionalDefaultValue : undefined,
              maybe_answers
            }
          }
          return result
        }),
        dependencies: step.dependencies.map((f) => {
          return { ...f, is_met: false, dependency: { ...f.dependency, Kind: f.dependency_kind } }
        })
      }))

      const res: HttpResult<FormData> = { kind: 'result', status: 200, value: data }
      return res
    })
  }
  return res as any
}

export async function upload_files(form_id: number, upload_hash: string, files: File[]): Promise<void> {
  const files_data = new FormData()
  files.forEach((file) => files_data.append(file.name, file))
  files_data.append('upload_hash', upload_hash)

  // let allowed_extensions = ["txt", "rtf", "pdf", "doc", "docx", "odt", "tex", "wpd"]
  // let extension = file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name
  // if (!allowed_extensions.includes(extension)) {
  //   window.alert("This file type is not allowed")
  //   return
  // }

  const headers = new Headers()
  headers.append('X-XSRF-TOKEN', (document.getElementsByName('__RequestVerificationToken')[0] as any).value)
  const res = await fetch(`/api/v1/CustomFormLogic/SubmitFormData/FileUpload/${form_id}`, {
    method: 'POST',
    body: files_data,
    credentials: 'include',
    headers: headers
  })
  // TODO: We don't care that the request fails for now, since there's an unknown error in the file upload. Fix this when the fileUpload error is solved in .NET
  // if (!res.ok) throw Error(res.statusText)

  return
}

// export let GetFormTitles = (events: string[]): FormState => {
//   let res: FormState = {
//     form_submission_logic: unloadedAsyncState(),
//     dependencies_state: Immutable.Map(),
//     context: {
//       external_options: Immutable.Map<string, string[]>().set("locationArray", events)
//     },
//     form_data: loadingAsyncState(async () => {
//       let fetch_res = await fetch(`/api/v1/CustomFormLogic/GetFormTitles`, { method: 'get', credentials: 'include', headers: { 'content-type': 'application/json' } })
//       if (!fetch_res.ok) return { kind: "failed", status: 400 }
//       let data = await fetch_res.json()
//       data.steps = data.steps.map(step =>
//         ({
//           ...step,
//           fields: step.fields.map(f => {
//             let field = f.field
//             let maybe_answers = f.maybe_answers
//             let result = { ...field, user_input: field.optionalDefaultValue ? field.optionalDefaultValue : undefined, maybe_answers }
//             return result
//           }),
//           dependencies: step.dependencies.map(f => {
//             return { ...f, is_met: false }
//           })
//         }))

//       let res: HttpResult<FormData> = { kind: "result", status: 200, value: data }
//       return res
//     }),
//   }
//   return res as any
// }
